module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Dual Camera Module.c4005aef.png";